class WorkspaceDto {
    Id: number;
    Name: string;
    IsCurrent: boolean;

    constructor(id: number, name: string, isCurrent: boolean = false) {
        this.Id = id;
        this.Name = name;
        this.IsCurrent = isCurrent;
    }
}

export default WorkspaceDto;
